import { ApiService, type ApiRequestConfig } from "./api.service";

export interface ICurrencyOption {
  /** ISO 4217 code stored on the workspace (e.g. "USD", "EUR"). */
  code: string;
  /** Human label for the picker (e.g. "US Dollar"). */
  name: string;
}

export class CurrencyService extends ApiService {
  async listCurrencies(config?: ApiRequestConfig): Promise<ICurrencyOption[]> {
    const response = await this.get<{ currencies: ICurrencyOption[] }>("/api/currencies/", config);
    return response.currencies;
  }
}
